import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "page-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rule = _resolveComponent("Rule")!
  const _component_Line = _resolveComponent("Line")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Share = _resolveComponent("Share")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.page)))
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode(_component_Rule, null, null, 512), [
      [_vShow, _ctx.ruleShow]
    ]),
    (_ctx.lineShow)
      ? (_openBlock(), _createBlock(_component_Line, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.messageData)
      ? (_openBlock(), _createBlock(_component_Message, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.shareImgData)
      ? (_openBlock(), _createBlock(_component_Share, {
          key: 2,
          isApp: _ctx.isApp
        }, null, 8, ["isApp"]))
      : _createCommentVNode("", true)
  ]))
}